import request from '@/utils/request'

// 列表
export function listPage(data) {
  return request({
    url: 'admin/data/materials/list',
    method: 'post',
    data
  })
}
// 列表
export function CompListPage(data) {
  return request({
    url: 'admin/data/materialscomp/list',
    method: 'post',
    data
  })
}

// 下一个书签
export function nextBookmark(data) {
  return request({
    url: 'admin/data/materials/nextBookmark',
    method: 'post',
    data
  })
}

// 上一个书签
export function previousBookmark(data) {
  return request({
    url: 'admin/data/materials/previousBookmark',
    method: 'post',
    data
  })
}

// 添加书签
export function addBookmark(data) {
  return request({
    url: 'admin/data/materials/addBookmark',
    method: 'post',
    data
  })
}

// 删除书签
export function delBookmark(data) {
  return request({
    url: 'admin/data/materials/delBookmark',
    method: 'post',
    data
  })
}

// 下拉信息初始化
export function addSelectInit() {
  return request({
    url: 'admin/data/materials/init',
    method: 'get'
  })
}

// 详情
export function info(id) {
  return request({
    url: 'admin/data/materials/info/' + id,
    method: 'get'
  })
}
// 详情
export function compInfo(id) {
  return request({
    url: 'admin/data/materialscomp/info/' + id,
    method: 'get'
  })
}

// 添加应急物资
export function insertUpdatePlan(data) {
  return request({
    url: 'admin/data/materials/insertUpdatePlan',
    method: 'post',
    data
  })
}
// 导入
export function importData(data) {
  return request({
    url: 'admin/data/materials/importCompData',
    method: 'post',
    data
  })
}

// 删除物资
export function deleteHandle(data) {
  return request({
    url: 'admin/data/materials/del',
    method: 'post',
    data
  })
}
// 删除物资
export function compDeleteHandle(data) {
  return request({
    url: 'admin/data/materialscomp/del ',
    method: 'post',
    data
  })
}

// 详情
export function companyInfo(id) {
  return request({
    url: 'admin/prj/company/info/' + id,
    method: 'get'
  })
}